import { useCallback } from "react"
import { graphql, UseMutationConfig } from "react-relay"
import { type CustomMutationParams, useMutationWithErrorDialog } from "@/hooks/useMutationWithErrorDialog"
import { useDeUpdateLegalGuardianAttestationMutation as useDeUpdateLegalGuardianAttestationMutationType } from "@/modules/patients/detail/legal-guardian-attestation/de/services/__generated__/useDeUpdateLegalGuardianAttestationMutation.graphql"

const mutation = graphql`
  mutation useDeUpdateLegalGuardianAttestationMutation($input: De_updateAttestationGuardianInput!) {
    de_updateAttestationGuardian(input: $input) {
      de_AttestationGuardian {
        id
        ...deLegalGuardianAttestationFragment
      }
      errors {
        ... on Error {
          message
        }
      }
    }
  }
`

const useDeUpdateLegalGuardianAttestationMutation = (params?: CustomMutationParams) => {
  const [commit, isFlight] = useMutationWithErrorDialog<useDeUpdateLegalGuardianAttestationMutationType>(
    mutation,
    params,
  )

  const commitHandler = useCallback(
    (config: UseMutationConfig<useDeUpdateLegalGuardianAttestationMutationType>) => {
      commit(config)
    },
    [commit],
  )

  return [commitHandler, isFlight] as const
}

export { useDeUpdateLegalGuardianAttestationMutation }
